import MyLeadsRedirectScreen from "@/screens/MyLeadsRedirectScreen"

export default MyLeadsRedirectScreen
